export const editQuoteBannerDataLocator = {
    edit_quote_banner_CTA: 'edit_quote_banner_CTA',
    edit_quote_modal_continue_CTA: 'edit_quote_modal_continue_CTA',
    edit_quote_modal_cancel_CTA: 'edit_quote_modal_cancel_CTA',
};